import { useSelector } from "react-redux";

import { agentMatchSelector } from "../../selectors/selectors";

export const useAgentMatchData = () => useSelector(agentMatchSelector);
